import { setHrkDualPricesEnabled } from "../../../output/Restaumatic.I18n.Currency";
export function initHrkDualPrices() {
    if (shouldEnableHrkDualPrices()) {
        console.log("Enabling HRK dual prices");
        setHrkDualPricesEnabled(true)();
    }
    else {
        console.log(`HRK dual prices disabled, country=${Skubacz.configuration.country}`);
    }
}
export function shouldEnableHrkDualPrices() {
    return shouldEnableHrkDualPricesInCountry(Skubacz.configuration.country);
}
export function shouldEnableHrkDualPricesInCountry(country) {
    return country === "HR";
}
